import { render, staticRenderFns } from "./PetEvents.vue?vue&type=template&id=422d8f4e&scoped=true"
import script from "./PetEvents.vue?vue&type=script&lang=js"
export * from "./PetEvents.vue?vue&type=script&lang=js"
import style0 from "./PetEvents.vue?vue&type=style&index=0&id=422d8f4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d8f4e",
  null
  
)

export default component.exports